/* src/app/umbrella-common/components/status-label/status-label.style.scss */
.rectangle {
  height: 16px;
  border-radius: 16px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.status-text {
  width: 54px;
  font-size: 0.5rem;
  font-weight: bold;
  line-height: 1.25;
  letter-spacing: 0.44px;
  text-align: center;
  color: white;
  white-space: nowrap;
}
.forecasted {
  background-color: #0044b1;
  width: 95px;
}
.draft {
  background-color: #8c8c8c;
  width: 70px;
}
.declined {
  background-color: #d7273d;
  width: 80px;
}
.preview {
  width: 80px;
  background-color: #ee7f00;
}
.confirmed {
  width: 80px;
  background-color: #0d7c40;
}
.sent {
  background-color: #7BBA2E;
  width: 95px;
}
.sent .status-text {
  width: 80px !important;
}
.client_change {
  width: 95px;
  background-color: #d7273d;
}
.client_change .status-text {
  width: 80px !important;
}
.closed {
  width: 60px;
  height: 16px;
  background-color: #3173de;
}
/*# sourceMappingURL=status-label.style.css.map */
